module.exports = __webpack_public_path__ + "media/images/favicons/favicon-507d37ce0fb0f8809bb18dd5c9f6d144.ico";